function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length) linkElements.forEach(button => {
          button.removeAttribute('tabindex');
        });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length) linkElements.forEach(button => {
          button.setAttribute('tabindex', '-1');
        });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach(mediaGallery => mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true));

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch(e => {
          console.error(e);
        });
    }

    new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 400px 0px'}).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

// Hotfix for Product Munchables editor slider sync when section files exceed Shopify upload size limits.
(function initProteinMunchablesDecorationHotfix() {
  const SECTION_SELECTOR = '.product-feastables';
  const MAIN_IMAGE_SELECTOR = '#main-product-image.product-feastables__main-image';
  const FLAVOR_RADIO_SELECTOR = '.product-feastables__flavor-radio:checked';

  function toNumber(value, fallback) {
    const parsed = parseFloat(value);
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function getMainImageEl() {
    return document.querySelector(MAIN_IMAGE_SELECTOR);
  }

  function getCheckedFlavorRadio(root) {
    return (root || document).querySelector(FLAVOR_RADIO_SELECTOR);
  }

  function isMobileDecorationContext(mainImageEl) {
    if (window.matchMedia('(max-width: 767px)').matches) return true;

    if (window.Shopify && Shopify.designMode && mainImageEl) {
      try {
        const params = new URLSearchParams(window.location.search);
        const previewMode = (params.get('previewMode') || '').toLowerCase();
        if (previewMode === 'mobile') return true;
      } catch (e) {}

      const sectionEl = mainImageEl.closest(SECTION_SELECTOR);
      const probeEl = sectionEl || mainImageEl;
      const renderedWidth = probeEl.getBoundingClientRect().width;
      if (renderedWidth > 0 && renderedWidth <= 980) return true;
      if (window.innerHeight > window.innerWidth) return true;
    }

    return false;
  }

  function applyIconDistancePositions(mainImageEl, horizontalDistance, verticalDistance, bottomLiftPx, bottomTightenPx) {
    if (!mainImageEl) return;

    const h = String(horizontalDistance);
    const v = String(verticalDistance);
    const lift = String(bottomLiftPx);
    const tighten = String(bottomTightenPx);

    const setPos = (selector, styles) => {
      const el = mainImageEl.querySelector(selector);
      if (!el) return;
      Object.keys(styles).forEach((key) => {
        el.style[key] = styles[key];
      });
    };

    setPos('.product-page__flavor-icon--1', { top: `calc(5% - ${v}%)`, left: `calc(5% - ${h}%)`, right: '', bottom: '' });
    setPos('.product-page__flavor-icon--2', { top: `calc(5% - ${v}%)`, right: `calc(5% - ${h}%)`, left: '', bottom: '' });
    setPos('.product-page__flavor-icon--3', { top: '50%', right: `calc(0% - ${h}%)`, left: '', bottom: '' });
    setPos('.product-page__flavor-icon--4', { bottom: `calc((5% - ${v}%) + ${lift}px)`, right: `calc((10% - ${h}%) + ${tighten}px)`, top: '', left: '' });
    setPos('.product-page__flavor-icon--5', { bottom: `calc((0% - ${v}%) + ${lift}px)`, left: '50%', top: '', right: '' });
    setPos('.product-page__flavor-icon--6', { bottom: `calc((5% - ${v}%) + ${lift}px)`, left: `calc((10% - ${h}%) + ${tighten}px)`, top: '', right: '' });
    setPos('.product-page__flavor-icon--7', { top: '50%', left: `calc(0% - ${h}%)`, right: '', bottom: '' });
    setPos('.product-page__flavor-icon--8', { top: `calc(0% - ${v}%)`, left: '50%', right: '', bottom: '' });
  }

  function applyFlavorDecorationHotfix(radio) {
    if (!radio) return;
    const mainImageEl = getMainImageEl();
    if (!mainImageEl) return;

    const iconsSize = toNumber(radio.dataset.iconsSize, 60);
    const splashSize = toNumber(radio.dataset.splashSize, 400);
    const iconDistance = toNumber(radio.dataset.iconDistance, 10);
    const iconDistanceV = toNumber(radio.dataset.iconDistanceV, 10);
    const splashOffsetX = toNumber(radio.dataset.splashOffsetX, 0);
    const splashOffsetY = toNumber(radio.dataset.splashOffsetY, 0);

    const iconsSizeMobile = toNumber(radio.dataset.iconsSizeMobile, iconsSize);
    const splashSizeMobileRaw = toNumber(radio.dataset.splashSizeMobile, splashSize);
    // Theme schema currently clamps mobile splash slider minimum to 100.
    // Normalize so 100 behaves as 0 until the oversized section schema can be reduced and fixed.
    const splashSizeMobile = Math.max(0, splashSizeMobileRaw - 100);
    const iconDistanceMobile = toNumber(radio.dataset.iconDistanceMobile, iconDistance);
    const iconDistanceVMobile = toNumber(radio.dataset.iconDistanceVMobile, iconDistanceV);
    const splashOffsetXMobile = toNumber(radio.dataset.splashOffsetXMobile, splashOffsetX);
    const splashOffsetYMobile = toNumber(radio.dataset.splashOffsetYMobile, splashOffsetY);
    const bottomIconsLiftMobile = toNumber(radio.dataset.bottomIconsLiftMobile, 0);
    const bottomIconsTightenMobile = toNumber(radio.dataset.bottomIconsTightenMobile, 0);

    mainImageEl.style.setProperty('--flavor-icons-size', `${iconsSize}px`, 'important');
    mainImageEl.style.setProperty('--splash-size', `${splashSize}px`, 'important');
    mainImageEl.style.setProperty('--icon-distance', `${iconDistance}%`, 'important');
    mainImageEl.style.setProperty('--icon-distance-v', `${iconDistanceV}%`, 'important');
    mainImageEl.style.setProperty('--splash-offset-x', `${splashOffsetX}px`, 'important');
    mainImageEl.style.setProperty('--splash-offset-y', `${splashOffsetY}px`, 'important');
    mainImageEl.style.setProperty('--flavor-icons-size-mobile', `${iconsSizeMobile}px`, 'important');
    mainImageEl.style.setProperty('--splash-size-mobile', `${splashSizeMobile}px`, 'important');
    mainImageEl.style.setProperty('--icon-distance-mobile', `${iconDistanceMobile}%`, 'important');
    mainImageEl.style.setProperty('--icon-distance-v-mobile', `${iconDistanceVMobile}%`, 'important');
    mainImageEl.style.setProperty('--splash-offset-x-mobile', `${splashOffsetXMobile}px`, 'important');
    mainImageEl.style.setProperty('--splash-offset-y-mobile', `${splashOffsetYMobile}px`, 'important');

    const mobileView = isMobileDecorationContext(mainImageEl);
    const activeIconDistance = mobileView ? iconDistanceMobile : iconDistance;
    const activeIconDistanceV = mobileView ? iconDistanceVMobile : iconDistanceV;
    const activeBottomLift = mobileView ? bottomIconsLiftMobile : 0;
    const activeBottomTighten = mobileView ? bottomIconsTightenMobile : 0;
    const activeSplashSize = mobileView ? splashSizeMobile : splashSize;
    const activeX = mobileView ? splashOffsetXMobile : splashOffsetX;
    const activeY = mobileView ? splashOffsetYMobile : splashOffsetY;

    applyIconDistancePositions(mainImageEl, activeIconDistance, activeIconDistanceV, activeBottomLift, activeBottomTighten);

    // Enforce layer order during hover:
    // chips/icons above product pack, and splash behind both.
    const packMediaEl = mainImageEl.querySelector('#main-image, #product-video');
    const chipIconEls = mainImageEl.querySelectorAll('.product-page__flavor-icon:not(.product-page__flavor-icon--9)');
    if (packMediaEl) {
      packMediaEl.style.position = 'relative';
      packMediaEl.style.zIndex = '30';
    }
    chipIconEls.forEach((iconEl) => {
      iconEl.style.zIndex = '50';
    });

    const splashEl = mainImageEl.querySelector('.product-page__flavor-icon--9');
    if (splashEl) {
      splashEl.style.width = `${activeSplashSize}px`;
      splashEl.style.height = `${activeSplashSize}px`;
      splashEl.style.left = `calc(50% + ${activeX}px)`;
      splashEl.style.top = `calc(50% + ${activeY}px)`;
      splashEl.style.zIndex = '10';
      splashEl.style.opacity = '';
      splashEl.style.display = activeSplashSize <= 0 ? 'none' : '';
    }
  }

  function syncCurrentFlavor() {
    const radio = getCheckedFlavorRadio();
    if (!radio) return;
    applyFlavorDecorationHotfix(radio);
  }

  function setup() {
    if (!document.querySelector(SECTION_SELECTOR)) return;
    syncCurrentFlavor();
  }

  document.addEventListener('change', (event) => {
    const target = event.target;
    if (!(target instanceof HTMLInputElement)) return;
    if (!target.matches('.product-feastables__flavor-radio')) return;
    applyFlavorDecorationHotfix(target);
  });

  window.addEventListener('resize', syncCurrentFlavor);
  document.addEventListener('shopify:section:load', setup);
  document.addEventListener('shopify:block:select', syncCurrentFlavor);
  document.addEventListener('DOMContentLoaded', setup);
  window.addEventListener('load', setup);

  if (window.Shopify && Shopify.designMode) {
    let snapshot = '';
    window.setInterval(() => {
      const radio = getCheckedFlavorRadio();
      if (!radio) return;

      const mobileView = isMobileDecorationContext(getMainImageEl()) ? '1' : '0';
      const next = [
        radio.dataset.splashSize || '',
        radio.dataset.splashSizeMobile || '',
        radio.dataset.iconDistance || '',
        radio.dataset.iconDistanceMobile || '',
        radio.dataset.iconDistanceV || '',
        radio.dataset.iconDistanceVMobile || '',
        radio.dataset.splashOffsetX || '',
        radio.dataset.splashOffsetXMobile || '',
        radio.dataset.splashOffsetY || '',
        radio.dataset.splashOffsetYMobile || '',
        radio.dataset.bottomIconsLiftMobile || '',
        radio.dataset.bottomIconsTightenMobile || '',
        mobileView
      ].join('|');

      if (next !== snapshot) {
        snapshot = next;
        applyFlavorDecorationHotfix(radio);
      }
    }, 250);
  }
})();

// Keep rotating character video visible if a flavor lacks media fields.
(function initProteinMunchablesCharacterVideoFallback() {
  const SECTION_SELECTOR = '.product-feastables__character-section';
  const FLAVOR_RADIO_SELECTOR = '.product-feastables__flavor-radio';

  let cachedVideoSrc = '';
  let cachedImageSrc = '';

  function isMobileCharacterVideoContext() {
    if (window.Shopify && Shopify.designMode) {
      try {
        const params = new URLSearchParams(window.location.search || '');
        const previewMode = (params.get('previewMode') || '').toLowerCase();
        if (previewMode === 'mobile') return true;
        if (previewMode === 'desktop' || previewMode === 'full-screen' || previewMode === 'fullscreen') return false;
      } catch (e) {}
      return false;
    }
    return window.matchMedia('(max-width: 767px)').matches;
  }

  function syncCharacterVideoVisibility(videoEl) {
    if (!videoEl) return;

    const section = videoEl.closest('.product-feastables__character-section');
    const canvas = section ? section.querySelector('#product-character-video-canvas') : null;
    const canvasIsVisible = !!(canvas && window.getComputedStyle(canvas).display !== 'none');

    // When matte-key canvas is active, keep raw video hidden to avoid ghost/double render.
    if (canvasIsVisible) {
      videoEl.style.opacity = '0';
    } else {
      videoEl.style.opacity = '1';
    }

    videoEl.style.display = 'block';
    videoEl.style.visibility = 'visible';
    videoEl.style.pointerEvents = 'none';
  }

  function cacheCurrentSources() {
    const videoEl = document.getElementById('product-character-video');
    const imageEl = document.getElementById('product-character-image');
    if (videoEl && videoEl.src) cachedVideoSrc = videoEl.src;
    if (imageEl && imageEl.src) cachedImageSrc = imageEl.src;
  }

  function restoreCharacterMediaIfHidden() {
    const sectionEl = document.querySelector(SECTION_SELECTOR);
    if (!sectionEl) return;

    const videoEl = document.getElementById('product-character-video');
    const imageEl = document.getElementById('product-character-image');

    if (cachedVideoSrc) {
      sectionEl.style.display = 'flex';
      if (imageEl) imageEl.style.display = 'none';

      let activeVideo = videoEl;
      if (!activeVideo) {
        activeVideo = document.createElement('video');
        activeVideo.id = 'product-character-video';
        activeVideo.className = 'product-feastables__character-video';
        activeVideo.autoplay = true;
        activeVideo.loop = true;
        activeVideo.muted = true;
        activeVideo.playsInline = true;
        activeVideo.preload = 'auto';
        sectionEl.prepend(activeVideo);
      }

      syncCharacterVideoVisibility(activeVideo);
      if (activeVideo.src !== cachedVideoSrc) {
        activeVideo.src = cachedVideoSrc;
        activeVideo.load();
      }
      activeVideo.play().catch(() => {});
      return;
    }

    if (cachedImageSrc) {
      sectionEl.style.display = 'flex';
      if (videoEl) videoEl.style.display = 'none';
      if (imageEl) {
        imageEl.style.display = 'block';
        if (!imageEl.src) imageEl.src = cachedImageSrc;
      }
    } else {
      sectionEl.style.display = 'none';
    }
  }

  function syncFromSelectedFlavor() {
    const checked = document.querySelector(`${FLAVOR_RADIO_SELECTOR}:checked`);
    if (!checked) {
      cacheCurrentSources();
      restoreCharacterMediaIfHidden();
      return;
    }

    const dataVideo = checked.dataset.characterVideo || checked.dataset.characterVideoMobile || '';
    const dataImage = checked.dataset.character1 || '';
    cachedVideoSrc = dataVideo || '';
    cachedImageSrc = dataImage || '';
    restoreCharacterMediaIfHidden();

    // Remove accidental duplicate video nodes from previous fallback passes.
    const section = document.querySelector(SECTION_SELECTOR);
    if (section) {
      const videos = section.querySelectorAll('#product-character-video');
      if (videos.length > 1) {
        videos.forEach((node, idx) => {
          if (idx > 0) node.remove();
        });
      }
      const activeVideo = section.querySelector('#product-character-video');
      if (activeVideo) syncCharacterVideoVisibility(activeVideo);
    }
  }

  document.addEventListener('change', (event) => {
    const target = event.target;
    if (!(target instanceof HTMLInputElement)) return;
    if (!target.matches(FLAVOR_RADIO_SELECTOR)) return;
    setTimeout(syncFromSelectedFlavor, 0);
    setTimeout(syncFromSelectedFlavor, 120);
  });

  document.addEventListener('shopify:section:load', () => {
    setTimeout(syncFromSelectedFlavor, 0);
    setTimeout(syncFromSelectedFlavor, 150);
  });
  document.addEventListener('DOMContentLoaded', () => {
    setTimeout(syncFromSelectedFlavor, 0);
    setTimeout(syncFromSelectedFlavor, 150);
  });
  window.addEventListener('load', () => {
    setTimeout(syncFromSelectedFlavor, 0);
    setTimeout(syncFromSelectedFlavor, 200);
  });

  window.setInterval(syncFromSelectedFlavor, 500);
})();

// Hard force readable Product Highlights stat text in mobile/editor preview.
(function initProductHighlightsStatReadabilityHotfix() {
  function inMobileContext() {
    let previewMobile = false;
    try {
      const params = new URLSearchParams(window.location.search || '');
      previewMobile = (params.get('previewMode') || '').toLowerCase() === 'mobile';
    } catch (e) {}
    const editorNarrow = !!(window.Shopify && Shopify.designMode && window.innerWidth <= 1024);
    return previewMobile || editorNarrow || window.matchMedia('(max-width: 989px)').matches;
  }

  function enforceStatTextSizing() {
    if (!inMobileContext()) return;

    const sectionEls = document.querySelectorAll('.product-highlights');
    sectionEls.forEach((section) => {
      // Prevent settings-based shrink from making labels unreadable in mobile/editor.
      section.style.setProperty('--ph-item-scale-mobile', '1', 'important');
      section.style.setProperty('--ph-text-scale-mobile', '1', 'important');
    });

    const itemEls = document.querySelectorAll('.product-highlights .product-highlights__item');
    const valueEls = document.querySelectorAll('.product-highlights .product-highlights__item .product-highlights__value');
    const labelEls = document.querySelectorAll('.product-highlights .product-highlights__item .product-highlights__label');

    itemEls.forEach((el) => {
      el.style.setProperty('transform', 'none', 'important');
      el.style.setProperty('max-width', '96px', 'important');
    });

    valueEls.forEach((el) => {
      el.style.setProperty('font-size', '24px', 'important');
      el.style.setProperty('line-height', '1.02', 'important');
      el.style.setProperty('font-weight', '800', 'important');
      el.style.setProperty('text-align', 'center', 'important');
      el.style.setProperty('margin', '0', 'important');
    });

    labelEls.forEach((el) => {
      el.style.setProperty('font-size', '14px', 'important');
      el.style.setProperty('line-height', '1.02', 'important');
      el.style.setProperty('font-weight', '900', 'important');
      el.style.setProperty('letter-spacing', '0.01em', 'important');
      el.style.setProperty('text-transform', 'uppercase', 'important');
      el.style.setProperty('text-align', 'center', 'important');
      el.style.setProperty('margin-top', '-0.28em', 'important');
      el.style.setProperty('margin-bottom', '0', 'important');
    });
  }

  function start() {
    enforceStatTextSizing();

    if (document.body && !document.body._pmHighlightsStatObserver) {
      const observer = new MutationObserver(() => enforceStatTextSizing());
      observer.observe(document.body, { childList: true, subtree: true, attributes: true });
      document.body._pmHighlightsStatObserver = observer;
    }
  }

  document.addEventListener('DOMContentLoaded', start);
  window.addEventListener('load', start);
  window.addEventListener('resize', enforceStatTextSizing);
  setInterval(enforceStatTextSizing, 400);
})();

// Product Protein Munchables: split "OF PROTEIN/FIBRE" into two lines
// with larger second line while keeping label-size slider influence.
(function initProteinMunchablesLabelLineBreakHotfix() {
  function styleWordSplitLabels() {
    const labels = document.querySelectorAll('.product-feastables__nutrition-label');
    labels.forEach((labelEl) => {
      if (!labelEl || labelEl.dataset.pmWordSplitReady === 'true') return;

      const rawText = (labelEl.textContent || '').trim();
      if (!rawText) return;

      const match = rawText.match(/^of\s+(.+)$/i);
      const hasOfPrefix = !!match;
      const tail = hasOfPrefix ? match[1].trim() : rawText.trim();
      if (!tail) return;

      labelEl.innerHTML = '';

      const top = document.createElement('span');
      top.className = 'pm-nutrition-label-top';
      top.textContent = 'OF';
      if (!hasOfPrefix) {
        top.classList.add('pm-nutrition-label-top--ghost');
      }

      const bottom = document.createElement('span');
      bottom.className = 'pm-nutrition-label-bottom';
      bottom.textContent = tail.toUpperCase();

      labelEl.appendChild(top);
      labelEl.appendChild(bottom);
      labelEl.dataset.pmWordSplitReady = 'true';
    });
  }

  function ensureStyles() {
    const STYLE_ID = 'pm-nutrition-label-word-split-style';
    if (document.getElementById(STYLE_ID)) return;

    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      .product-feastables__nutrition-item {
        display: grid !important;
        grid-template-columns: 1fr !important;
        grid-template-rows: auto 2.8em 2.35em !important;
        row-gap: 0.1em !important;
        justify-items: center !important;
        align-items: center !important;
        align-items: center !important;
      }

      .product-feastables__nutrition-icon {
        margin-bottom: 0 !important;
      }

      .product-feastables__nutrition-value {
        min-height: 2.15em !important;
        height: 2.8em !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        text-align: center !important;
        margin: 0 !important;
      }

      .product-feastables__nutrition-label {
        min-height: 2.35em !important;
        height: 2.35em !important;
        width: 100% !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        text-align: center !important;
        margin: 0 !important;
      }

      .product-feastables__nutrition-label[data-pm-word-split-ready="true"] {
        display: flex !important;
        flex-direction: column !important;
        align-items: center !important;
        justify-content: center !important;
        line-height: 1 !important;
        text-align: center !important;
        gap: 0.08em !important;
      }

      .product-feastables__nutrition-label .pm-nutrition-label-top {
        font-size: 1.18em !important;
        font-weight: 900 !important;
        letter-spacing: 0.03em !important;
        line-height: 1 !important;
      }

      .product-feastables__nutrition-label .pm-nutrition-label-top--ghost {
        opacity: 0 !important;
        visibility: hidden !important;
      }

      .product-feastables__nutrition-label .pm-nutrition-label-bottom {
        font-size: 1.9em !important;
        font-weight: 900 !important;
        letter-spacing: 0.02em !important;
        line-height: 0.92 !important;
        margin-top: 0 !important;
      }

      /* All nutrition labels use the same two-row structure for consistent baseline. */
    `;
    document.head.appendChild(style);
  }

  function run() {
    ensureStyles();
    styleWordSplitLabels();
  }

  document.addEventListener('DOMContentLoaded', run);
  window.addEventListener('load', run);
  window.addEventListener('resize', run);

  setInterval(run, 500);

  if (document.body && !document.body._pmNutritionLabelObserver) {
    const observer = new MutationObserver(run);
    observer.observe(document.body, { childList: true, subtree: true });
    document.body._pmNutritionLabelObserver = observer;
  }
})();

// Product Protein Munchables mobile layout order:
// plans -> nutrition button -> find store (instead of find store above plans)
(function initProteinMunchablesSubscriptionOrderHotfix() {
  function isMobileContext() {
    let previewMobile = false;
    try {
      const params = new URLSearchParams(window.location.search || '');
      previewMobile = (params.get('previewMode') || '').toLowerCase() === 'mobile';
    } catch (e) {}
    return previewMobile || window.matchMedia('(max-width: 989px)').matches;
  }

  function ensureStyles() {
    const STYLE_ID = 'pm-subscription-order-mobile-style';
    if (document.getElementById(STYLE_ID)) return;

    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      @media (max-width: 989px) {
        .product-subscription-widget .subscription-widget-heading {
          display: none !important;
        }

        .product-subscription-widget .pm-mobile-select-option-heading {
          display: block !important;
          font-size: 1.9rem !important;
          line-height: 1.05 !important;
          font-weight: 900 !important;
          text-transform: uppercase !important;
          letter-spacing: 0.01em !important;
          margin: 0 0 0.35rem 0 !important;
          text-align: left !important;
        }

        .product-subscription-widget .purchase-plan-price-row {
          display: flex !important;
          flex-direction: column !important;
          align-items: flex-start !important;
          gap: 0.08rem !important;
          margin-bottom: 0.55rem !important;
        }

        .product-subscription-widget .purchase-plan-price-label,
        .product-subscription-widget .subscription-frequency-label {
          font-size: 1.12rem !important;
          line-height: 1.05 !important;
          font-weight: 900 !important;
          letter-spacing: 0.01em !important;
        }

        .product-subscription-widget #purchase-plan-price,
        .product-subscription-widget .purchase-plan-price,
        .product-subscription-widget .purchase-plan-option-price,
        .product-subscription-widget .subscription-option-onetime-price,
        .product-subscription-widget .subscription-sale-price {
          font-size: 2.2rem !important;
          line-height: 1 !important;
          font-weight: 900 !important;
          letter-spacing: 0.01em !important;
        }

        .product-subscription-widget .subscription-option-title,
        .product-subscription-widget .purchase-plan-option-title,
        .product-subscription-widget .purchase-plan-option-name {
          font-size: 1.35rem !important;
          line-height: 1.05 !important;
          font-weight: 900 !important;
        }

        .product-subscription-widget .subscription-badge.flavor-badge,
        .product-subscription-widget .purchase-plan-badge {
          font-size: 0.86rem !important;
          line-height: 1 !important;
          font-weight: 900 !important;
        }

        .product-subscription-widget .subscription-frequency,
        .product-subscription-widget .purchase-plan-option-subtitle,
        .product-subscription-widget .purchase-plan-option-frequency {
          font-size: 0.98rem !important;
          line-height: 1.1 !important;
          font-weight: 800 !important;
        }

      }
    `;
    document.head.appendChild(style);
  }

  function applyOrder() {
    if (!isMobileContext()) return;

    const widget = document.querySelector('.product-subscription-widget');
    if (!widget) return;

    const infoSide = widget.closest('.product-feastables__info') || widget.parentElement;
    if (!infoSide) return;

    const nutritionWrap = infoSide.querySelector('.product-nutrition-accordion');
    const findStore = infoSide.querySelector('.product-feastables__find-store');
    if (!nutritionWrap) return;

    // Ensure custom heading exists at top of subscription widget.
    let selectHeading = widget.querySelector('.pm-mobile-select-option-heading');
    if (!selectHeading) {
      selectHeading = document.createElement('h3');
      selectHeading.className = 'pm-mobile-select-option-heading';
      selectHeading.textContent = 'Select an option';
      widget.insertBefore(selectHeading, widget.firstChild);
    }

    // Ensure selected price has a concrete value instead of duplicate "SELECT AN OPTION".
    const priceValueEl = widget.querySelector('#purchase-plan-price');
    if (priceValueEl) {
      const checkedPlan = widget.querySelector('input[name="purchase-plan"]:checked');
      const oneTimePlan = widget.querySelector('input[name="purchase-plan"][value="one-time"]');
      const sourcePlan = checkedPlan || oneTimePlan;
      const displayPrice = sourcePlan ? (sourcePlan.getAttribute('data-display-price') || '') : '';
      if (displayPrice && /select an option/i.test((priceValueEl.textContent || '').trim())) {
        priceValueEl.textContent = displayPrice;
      }
    }

    // Move Find Store below Nutrition button area (exact requested order).
    if (findStore && nutritionWrap.parentElement === infoSide) {
      if (findStore.parentElement !== infoSide || findStore.previousElementSibling !== nutritionWrap) {
        infoSide.insertBefore(findStore, nutritionWrap.nextSibling);
      }
    }

  }

  function run() {
    ensureStyles();
    applyOrder();
  }

  document.addEventListener('DOMContentLoaded', run);
  window.addEventListener('load', run);
  window.addEventListener('resize', run);

  setInterval(run, 500);

  if (document.body && !document.body._pmSubscriptionOrderObserver) {
    const observer = new MutationObserver(run);
    observer.observe(document.body, { childList: true, subtree: true });
    document.body._pmSubscriptionOrderObserver = observer;
  }
})();

// Product Protein Munchables: prevent bottom of character pushup from clipping on mobile.
(function initProteinMunchablesCharacterBottomClipHotfix() {
  function inMobileContext() {
    let previewMobile = false;
    try {
      const params = new URLSearchParams(window.location.search || '');
      previewMobile = (params.get('previewMode') || '').toLowerCase() === 'mobile';
    } catch (e) {}
    return previewMobile || window.matchMedia('(max-width: 989px)').matches;
  }

  function apply() {
    const section = document.querySelector('.product-feastables__character-section');
    if (!section) return;

    // Fully disable this hotfix and restore native section sizing behavior.
    section.style.removeProperty('min-height');
    section.style.removeProperty('padding-bottom');
    section.style.removeProperty('margin-bottom');
    section.style.removeProperty('z-index');
    section.style.removeProperty('overflow');

    const video = section.querySelector('#product-character-video');
    const canvas = section.querySelector('#product-character-video-canvas');

    [video, canvas].forEach((el) => {
      if (!el) return;
      el.style.removeProperty('margin-bottom');
    });
  }

  document.addEventListener('DOMContentLoaded', apply);
  window.addEventListener('load', apply);
  window.addEventListener('resize', apply);
  // Desktop editor helper only; avoid continuous polling on live/mobile.
  if (window.Shopify && Shopify.designMode) {
    setInterval(apply, 1200);
  }
})();

// Product Highlights: boost rotating pack media on desktop preview
// even when editor viewport width is constrained by side panels.
(function initProductHighlightsDesktopMediaBoostHotfix() {
  function isMobileContext() {
    const viewportMobile = window.matchMedia('(max-width: 989px)').matches;
    try {
      const params = new URLSearchParams(window.location.search || '');
      const previewMobile = (params.get('previewMode') || '').toLowerCase() === 'mobile';
      // In Shopify editor, desktop preview can be narrow due to side panels.
      // Only treat explicit previewMode=mobile as mobile there.
      if (window.Shopify && Shopify.designMode) return previewMobile;
      return previewMobile || viewportMobile;
    } catch (e) {
      return viewportMobile;
    }
  }

  function apply() {
    // This hotfix is desktop-only. Running it continuously on mobile can
    // cause unnecessary style churn and video jank.
    if (isMobileContext()) return;

    const center = document.querySelector('.product-highlights__center');
    if (!center) return;

    const mediaNodes = center.querySelectorAll('.product-highlights__video, .product-highlights__image');
    if (!mediaNodes.length) return;

    mediaNodes.forEach((media) => {
      media.style.removeProperty('width');
      media.style.removeProperty('max-width');
      media.style.removeProperty('transform');
      media.style.removeProperty('transform-origin');
    });
    return;
  }

  document.addEventListener('DOMContentLoaded', apply);
  window.addEventListener('load', apply);
  window.addEventListener('resize', apply);
  setInterval(apply, 500);
})();

// Product Protein Munchables: improve mobile review readability
// and prevent rating bars from collapsing to thin lines.
(function initProteinMunchablesMobileReviewsHotfix() {
  const STYLE_ID = 'pm-mobile-reviews-readability-style';
  const ROOT_SELECTOR = '.product-flavor-reviews-section';

  function inMobileContext() {
    const viewportMobile = window.matchMedia('(max-width: 989px)').matches;
    try {
      const params = new URLSearchParams(window.location.search || '');
      const previewMobile = (params.get('previewMode') || '').toLowerCase() === 'mobile';
      if (window.Shopify && Shopify.designMode) return previewMobile || viewportMobile;
      return previewMobile || viewportMobile;
    } catch (e) {
      return viewportMobile;
    }
  }

  function ensureStyles() {
    if (document.getElementById(STYLE_ID)) return;
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      @media (max-width: 989px) {
        ${ROOT_SELECTOR} .flavor-reviews-title {
          font-size: clamp(2.2rem, 9vw, 3rem) !important;
          line-height: 0.95 !important;
          margin-bottom: 1.8rem !important;
        }

        ${ROOT_SELECTOR} .flavor-reviews-average {
          padding: 1.4rem !important;
          gap: 1.25rem !important;
        }

        ${ROOT_SELECTOR} .flavor-reviews-average-score {
          font-size: clamp(5.2rem, 16vw, 6.4rem) !important;
        }

        ${ROOT_SELECTOR} .flavor-reviews-average-out-of {
          font-size: clamp(2rem, 6vw, 2.6rem) !important;
        }

        ${ROOT_SELECTOR} .flavor-reviews-average-count {
          font-size: 1.18rem !important;
        }

        ${ROOT_SELECTOR} .flavor-reviews-average-right {
          width: 100% !important;
          flex: 1 1 100% !important;
          min-width: 0 !important;
        }

        ${ROOT_SELECTOR} .rating-breakdown-row {
          width: 100% !important;
          gap: 0.6rem !important;
        }

        ${ROOT_SELECTOR} .rating-breakdown-label {
          min-width: 62px !important;
          font-size: 1.2rem !important;
        }

        ${ROOT_SELECTOR} .rating-breakdown-bar-container {
          flex: 1 1 auto !important;
          min-width: 150px !important;
          height: 16px !important;
          border-width: 2px !important;
          overflow: hidden !important;
        }

        ${ROOT_SELECTOR} .rating-breakdown-bar-fill {
          min-width: 2px !important;
          height: 100% !important;
          border-radius: 8px !important;
        }

        ${ROOT_SELECTOR} .rating-breakdown-percentage {
          min-width: 52px !important;
          font-size: 1.18rem !important;
        }

        ${ROOT_SELECTOR} .flavor-review-name {
          font-size: 1.16rem !important;
        }

        ${ROOT_SELECTOR} .flavor-review-text {
          font-size: 1.12rem !important;
          line-height: 1.5 !important;
        }

        ${ROOT_SELECTOR} .flavor-review-date {
          font-size: 1rem !important;
        }
      }
    `;
    document.head.appendChild(style);
  }

  function enforceBreakdownBarWidths(root) {
    if (!inMobileContext() || !root) return;
    const rows = root.querySelectorAll('.rating-breakdown-row');
    rows.forEach((row) => {
      const bar = row.querySelector('.rating-breakdown-bar-container');
      const fill = row.querySelector('.rating-breakdown-bar-fill');
      if (!bar || !fill) return;
      bar.style.setProperty('width', '100%', 'important');
      bar.style.setProperty('max-width', 'none', 'important');
      bar.style.setProperty('min-width', '150px', 'important');
      const widthPct = parseFloat((fill.style.width || '').replace('%', ''));
      if (Number.isFinite(widthPct) && widthPct > 0) {
        fill.style.setProperty('min-width', '2px', 'important');
      }
    });
  }

  function run() {
    ensureStyles();
    document.querySelectorAll(ROOT_SELECTOR).forEach((root) => enforceBreakdownBarWidths(root));
  }

  function start() {
    run();
    if (document.body && !document.body._pmMobileReviewsObserver) {
      const observer = new MutationObserver(() => run());
      observer.observe(document.body, { childList: true, subtree: true });
      document.body._pmMobileReviewsObserver = observer;
    }
  }

  document.addEventListener('DOMContentLoaded', start);
  window.addEventListener('load', start);
  window.addEventListener('resize', run);
  document.addEventListener('shopify:section:load', run);

  if (window.Shopify && Shopify.designMode) {
    setInterval(run, 800);
  }
})();

// Floating checkout shortcut under header cart icon
// shown only when cart has at least one item.
(function initHeaderCheckoutShortcut() {
  const BTN_ID = 'pm-header-checkout-shortcut';
  const STYLE_ID = 'pm-header-checkout-shortcut-style';

  function ensureStyles() {
    if (document.getElementById(STYLE_ID)) return;
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      #${BTN_ID} {
        position: fixed;
        z-index: 10020;
        display: none;
        align-items: center;
        justify-content: center;
        padding: 7px 14px;
        min-height: 32px;
        border-radius: 999px;
        border: 2px solid #000000;
        background: var(--add-to-bag-bg, #4A9EFF);
        color: #000000;
        box-shadow: 3px 3px 0 #000000;
        font-family: 'Ariston Comic Demo', 'Ariston Comic', sans-serif;
        font-size: 13px;
        font-weight: 900;
        letter-spacing: 0.02em;
        text-transform: uppercase;
        text-decoration: none;
        line-height: 1;
        pointer-events: auto;
      }
      #${BTN_ID}:hover {
        transform: translate(1px, 1px);
        box-shadow: 2px 2px 0 #000000;
      }
      @media (max-width: 989px) {
        #${BTN_ID} {
          padding: 6px 11px;
          min-height: 30px;
          font-size: 12px;
          box-shadow: 2px 2px 0 #000000;
        }
      }

      .pm-checkout-overlay {
        position: fixed;
        inset: 0;
        background: rgba(0, 0, 0, 0.7);
        z-index: 10040;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .pm-checkout-overlay__content {
        text-align: center;
        color: #ffffff;
      }

      .pm-checkout-overlay__icon {
        width: 170px;
        height: 170px;
        display: inline-block;
        animation: pm-checkout-spin 1.2s linear infinite;
      }

      .pm-checkout-overlay__icon img {
        width: 100%;
        height: 100%;
        object-fit: contain;
        display: block;
      }

      .pm-checkout-overlay__text {
        margin-top: 1rem;
        font-family: 'Ariston Comic Demo', 'Ariston Comic', sans-serif;
        font-size: 24px;
        font-weight: 900;
        text-transform: uppercase;
      }

      @keyframes pm-checkout-spin {
        0% { transform: rotate(0deg) scale(1); }
        50% { transform: rotate(180deg) scale(1.1); }
        100% { transform: rotate(360deg) scale(1); }
      }
    `;
    document.head.appendChild(style);
  }

  function showCheckoutOverlayThenGo() {
    const existing = document.querySelector('.pm-checkout-overlay');
    if (existing) existing.remove();
    const loaderImageUrl = window.pmLoaderImageUrl || '/assets/chippy-loader.png';

    const overlay = document.createElement('div');
    overlay.className = 'pm-checkout-overlay';
    overlay.innerHTML =
      '<div class="pm-checkout-overlay__content">' +
        '<div class="pm-checkout-overlay__icon"><img src="' + loaderImageUrl + '" alt="Preparing your order"></div>' +
        '<p class="pm-checkout-overlay__text">Preparing your order...</p>' +
      '</div>';
    document.body.appendChild(overlay);

    window.setTimeout(() => {
      window.location.href = '/checkout';
    }, 1400);
  }

  function ensureButton() {
    let btn = document.getElementById(BTN_ID);
    if (btn) return btn;
    btn = document.createElement('a');
    btn.id = BTN_ID;
    btn.href = '#';
    btn.textContent = 'Checkout';
    btn.setAttribute('aria-label', 'Checkout');
    btn.addEventListener('click', (event) => {
      event.preventDefault();
      showCheckoutOverlayThenGo();
    });
    document.body.appendChild(btn);
    return btn;
  }

  function getHeaderCartIcon() {
    return document.querySelector('#cart-icon-bubble') || document.querySelector('.header__icon--cart');
  }

  function getBubbleCount() {
    const bubble = document.querySelector('.cart-count-bubble');
    if (!bubble) return NaN;
    const numberEl = bubble.querySelector('span[aria-hidden="true"]') || bubble.querySelector('span');
    const text = ((numberEl && numberEl.textContent) || '').replace(/[^0-9]/g, '');
    const count = parseInt(text, 10);
    return Number.isFinite(count) ? count : NaN;
  }

  function ensureCartBubble(itemCount) {
    const icon = getHeaderCartIcon();
    if (!icon) return;

    let bubble = icon.querySelector('.cart-count-bubble');
    const normalizedCount = Math.max(0, Number(itemCount) || 0);

    if (normalizedCount <= 0) {
      if (bubble) bubble.remove();
      return;
    }

    if (!bubble) {
      bubble = document.createElement('div');
      bubble.className = 'cart-count-bubble';
      const countSpan = document.createElement('span');
      countSpan.setAttribute('aria-hidden', 'true');
      const srSpan = document.createElement('span');
      srSpan.className = 'visually-hidden';
      bubble.appendChild(countSpan);
      bubble.appendChild(srSpan);
      icon.appendChild(bubble);
    }

    const countSpan = bubble.querySelector('span[aria-hidden]') || bubble.querySelector('span');
    const srSpan = bubble.querySelector('.visually-hidden');
    if (countSpan) countSpan.textContent = String(normalizedCount);
    if (srSpan) srSpan.textContent = `${normalizedCount} items in cart`;
  }

  function placeButton(btn, icon) {
    if (!btn || !icon) return;
    const rect = icon.getBoundingClientRect();
    if (!rect || rect.width <= 0 || rect.height <= 0) return;
    const top = rect.bottom + 6;
    const left = rect.left + (rect.width / 2) - (btn.offsetWidth / 2);
    const maxLeft = window.innerWidth - btn.offsetWidth - 8;
    btn.style.top = `${Math.max(8, top)}px`;
    btn.style.left = `${Math.max(8, Math.min(left, maxLeft))}px`;
  }

  function setVisible(visible) {
    const btn = ensureButton();
    btn.style.display = visible ? 'inline-flex' : 'none';
    if (!visible) return;
    const icon = getHeaderCartIcon();
    if (icon) placeButton(btn, icon);
  }

  let refreshInFlight = false;
  function refreshFromServer() {
    if (refreshInFlight) return;
    refreshInFlight = true;
    fetch('/cart.js')
      .then((r) => r.json())
      .then((cart) => {
        const itemCount = Number(cart && cart.item_count) || 0;
        ensureCartBubble(itemCount);
        setVisible(itemCount > 0);
      })
      .catch(() => {})
      .finally(() => {
        refreshInFlight = false;
      });
  }

  function refresh() {
    ensureStyles();
    ensureButton();
    const count = getBubbleCount();
    if (Number.isFinite(count)) {
      setVisible(count > 0);
      return;
    }
    refreshFromServer();
  }

  function start() {
    refresh();

    if (document.body && !document.body._pmHeaderCheckoutObserver) {
      const observer = new MutationObserver(() => refresh());
      observer.observe(document.body, { childList: true, subtree: true, characterData: true });
      document.body._pmHeaderCheckoutObserver = observer;
    }
  }

  document.addEventListener('DOMContentLoaded', start);
  window.addEventListener('load', start);
  window.addEventListener('resize', refresh);
  window.addEventListener('scroll', refresh, { passive: true });
  window.addEventListener('focus', refresh);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') refresh();
  });
  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('pm:cart-updated', (event) => {
    const count = event && event.detail ? Number(event.detail.item_count) : NaN;
    if (Number.isFinite(count)) {
      ensureCartBubble(count);
      setVisible(count > 0);
    } else {
      refresh();
    }
  });
  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!target || typeof target.closest !== 'function') return;
    const addBtn = target.closest('.product-feastables__add-to-bag');
    if (!addBtn) return;
    window.setTimeout(refreshFromServer, 900);
    window.setTimeout(refreshFromServer, 1800);
  }, true);

  if (window.Shopify && Shopify.designMode) {
    setInterval(refresh, 1200);
  }
})();
